<h1 mat-dialog-title i18n="@@einvoice.ios-install.title">Add to your Home Screen</h1>
<div mat-dialog-content>
  <p class="intro" i18n="@@einvoice.ios-install.intro">
    Add the e-invoice viewer to your Home Screen to open it like a normal app.
  </p>
  <ol class="steps">
    <li>
      <span i18n="@@einvoice.ios-install.step.share">Tap the Share button</span>
      <svg class="ios-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l4 4-1.4 1.4L13 6.8V15h-2V6.8L9.4 8.4 8 7l4-4z" />
        <path d="M5 11h2v8h10v-8h2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8z" />
      </svg>
      <span i18n="@@einvoice.ios-install.step.share.where">in your browser's toolbar.</span>
    </li>
    <li>
      <span i18n="@@einvoice.ios-install.step.scroll">In the menu, choose</span>
      <strong i18n="@@einvoice.ios-install.step.add-to-home">Add to Home Screen</strong>
      <svg class="ios-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5z" />
      </svg>
    </li>
    <li i18n="@@einvoice.ios-install.step.confirm">
      Confirm with Add – done!
    </li>
  </ol>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial i18n="@@einvoice.ios-install.button.close">Got it</button>
</div>
